//Used in customer and store add/edit page to show short card token.
export const SHORT_MASKED_CARD_TOKEN = 'shortMaskedToken';